import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {CouponType, CouponTypeObject, stampa_id} from "./SanPellegrino";
import {dateTimeStringToFormattedDate, getDateYear} from "../../Utility/DateUtility";


function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string) {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}



export function ReportSpedizioni(): OggettoConfig {
  var OBJ: OggettoConfig = {
    Id: "reportSped",
    fullListRoute: "/prodotti/list",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 50},
    ListResponseHasData:true,
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/reportSped",
        title: "Report Spedizioni",
        icon: "fa-solid fa-truck-fast",
        class: "",
        capacita: [],
        ruoliOperativi:["S", "SA"]
      },
    ],
    Filters:[
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "col-lg-9", ),
    ],

    Headers: [
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "", {modificabile: false}),
      campoCustom("Lotto",(coupon) =>getDateYear(coupon.dataScadenza1)?.toString()),
      campoCustom("Cliente (PV)", (coupon) => coupon.clienteObject?.nominativo ?? coupon.video ?? ""),
      campoCustom("Prodotto", (coupon)=>coupon.correlatiObject?.reduce((a,c)=>`${a} ${c.prodotto?.replaceAll("COUPON ", "")?.replaceAll("SELL IN ", "")?. replaceAll("SELL OUT ", "")?. replaceAll("OMAGGIO ", "")}`,'')),
      campoCustom("Codice Prodotto", (coupon)=>coupon.correlatiObject?.reduce((a,correlato)=>`${a} ${correlato.prodotto} `,'')),
      campoCustom("Manager", (coupon) => coupon.dmCoupon?.fullName ?? coupon.namCoupon?.fullName ?? ""),
      campoCustom("Agente", (coupon) => coupon.agenteCoupon?.fullName ?? ""),
      campoCustom("Data Bonifico", (coupon)=> coupon?.dataBonifico ? dateTimeStringToFormattedDate(coupon?.dataBonifico) : ''),
      campoCustom("DDT", (coupon)=>coupon?.ddt?.map(x=>x.numero)?.join(", ")),
      campoCustom("Data DDT", (coupon)=>coupon?.ddt?.map(x=>dateTimeStringToFormattedDate(x?.data_prevista))?.join(", ")),
      campoCustom("Data Assegnazione", (coupon) => coupon?.dataAssegnazione)

    ],
    DisableEdit: true,
    AzioniLista: [
      {
        nome: 'Scarica',
        close: false,
        icon: 'fas fa-paperclip text-info ',
        class: ' btn ',
        single: true,
        labelClass: 'text-info ',
        hideif:{func:(coupon)=>coupon.ddt?.some(x=>x?.files?.length>0)},
        type: 'func',
        tooltip: "Scarica il DDT",
        func: (coupon, api:ApiPathsService, end, toastService) => {
          console.log('Scarica il ddt :' , coupon);
          coupon.ddt?.flatMap(ddt => ddt.files ?? []).forEach(file => api.DownloadFileByID(file.id));

        }

      },
      //TODO: Tasto Tracking
    ]
  }


  return OBJ;
}


